import { useState, useEffect } from 'react'
import { Button } from '../common/Button'
import { Logo } from '../common/Logo'
import { FiMenu, FiX } from 'react-icons/fi'

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const appUrl = import.meta.env.VITE_APP_URL as string | undefined

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
      setIsMobileMenuOpen(false)
    }
  }

  const handleEnterClick = () => {
    if (appUrl) {
      window.location.href = appUrl
    }
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md'
          : 'bg-white/95 backdrop-blur-sm'
      }`}
      role="banner"
    >
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <button
              onClick={() => scrollToSection('hero')}
              className="transition-opacity hover:opacity-80"
            >
              <Logo size="md" showText={true} />
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-primary-600 transition-colors font-medium"
            >
              Funcionalidades
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-gray-700 hover:text-primary-600 transition-colors font-medium"
            >
              Preços
            </button>
            <Button
              onClick={handleEnterClick}
              variant="outline"
              size="md"
            >
              Entrar
            </Button>
            <Button
              onClick={() => scrollToSection('pricing')}
              variant="primary"
              size="md"
            >
              Começar Agora
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-primary-600 transition-colors"
          >
            {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <button
              onClick={() => scrollToSection('features')}
              className="block w-full text-left text-gray-700 hover:text-primary-600 transition-colors font-medium py-2"
            >
              Funcionalidades
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left text-gray-700 hover:text-primary-600 transition-colors font-medium py-2"
            >
              Preços
            </button>
            <Button
              onClick={() => {
                scrollToSection('pricing')
                setIsMobileMenuOpen(false)
              }}
              variant="primary"
              size="md"
              className="w-full"
            >
              Começar Agora
            </Button>
            <Button
              onClick={() => {
                handleEnterClick()
                setIsMobileMenuOpen(false)
              }}
              variant="outline"
              size="md"
              className="w-full"
            >
              Entrar
            </Button>
          </div>
        )}
      </nav>
    </header>
  )
}

